import { render, staticRenderFns } from "./DesktopVisitsTable.vue?vue&type=template&id=4bd7abd1&scoped=true"
import script from "./DesktopVisitsTable.vue?vue&type=script&lang=js"
export * from "./DesktopVisitsTable.vue?vue&type=script&lang=js"
import style0 from "./DesktopVisitsTable.vue?vue&type=style&index=0&id=4bd7abd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd7abd1",
  null
  
)

export default component.exports